import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, ChevronRight, Heart, ExternalLink } from 'lucide-react';
import { useSiteSettings } from '../hooks/useSiteSettings';

// Иконки соцсетей
const TelegramIcon = () => (
  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
  </svg>
);

const VKIcon = () => (
  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
    <path d="M15.684 0H8.316C1.592 0 0 1.592 0 8.316v7.368C0 22.408 1.592 24 8.316 24h7.368C22.408 24 24 22.408 24 15.684V8.316C24 1.592 22.408 0 15.684 0zm3.692 17.123h-1.744c-.66 0-.864-.525-2.05-1.727-1.033-1-1.49-1.135-1.744-1.135-.356 0-.458.102-.458.593v1.575c0 .424-.135.678-1.253.678-1.846 0-3.896-1.118-5.335-3.202C4.624 10.857 4.03 8.57 4.03 8.096c0-.254.102-.491.593-.491h1.744c.44 0 .61.203.78.677.863 2.49 2.303 4.675 2.896 4.675.22 0 .322-.102.322-.66V9.721c-.068-1.186-.695-1.287-.695-1.71 0-.204.17-.407.44-.407h2.744c.373 0 .508.203.508.643v3.473c0 .372.17.508.271.508.22 0 .407-.136.814-.542 1.27-1.422 2.18-3.61 2.18-3.61.119-.254.322-.491.763-.491h1.744c.525 0 .644.27.525.643-.22 1.017-2.354 4.031-2.354 4.031-.186.305-.254.44 0 .78.186.254.796.779 1.203 1.253.745.847 1.32 1.558 1.473 2.05.17.49-.085.744-.576.744z"/>
  </svg>
);

const AvitoIcon = () => (
  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 14.842c-.422 1.168-1.296 2.098-2.513 2.576-1.826.717-3.895.391-5.345-.835-.29-.245-.558-.517-.795-.815-.123.18-.24.365-.368.54-.927 1.266-2.165 2.061-3.75 2.228-.193.02-.389.031-.584.031-1.57 0-2.887-.726-3.568-2.002-.394-.74-.478-1.546-.246-2.343.243-.834.746-1.502 1.45-1.983 1.094-.748 2.34-.953 3.634-.784.627.082 1.231.262 1.795.552.057-.206.108-.412.174-.613.303-.93.762-1.78 1.415-2.517.928-1.049 2.104-1.694 3.518-1.886 1.007-.137 1.98-.015 2.89.415 1.095.517 1.838 1.358 2.212 2.514.387 1.199.27 2.372-.319 3.502-.297.57-.69 1.064-1.161 1.49.188.302.355.62.481.955.208.55.263 1.121.08 1.695z"/>
  </svg>
);

const SOCIAL_LINKS = [
  { icon: TelegramIcon, href: 'https://t.me/bigpineapple_rnd', label: 'Telegram' },
  { icon: VKIcon, href: 'https://vk.com/bigpineapple_rnd', label: 'ВКонтакте' },
];

const MARKETPLACE_LINKS = [
  { 
    name: 'Avito', 
    href: 'https://www.avito.ru/user/70e6ca34aed2cf56d4118d875b82a624/profile/all/predlozheniya_uslug?id=7852873478&src=item&page_from=from_item_card&iid=7852873478&sellerId=70e6ca34aed2cf56d4118d875b82a624',
    color: 'bg-[#00AAFF] hover:bg-[#0099EE]'
  },
  { 
    name: 'Ozon', 
    href: 'https://ozon.ru/seller/pineapple-1866878/?utm_source=site&utm_medium=cpc&utm_campaign=vendor_org_1358782',
    color: 'bg-[#005BFF] hover:bg-[#0047CC]'
  },
  { 
    name: 'Я.Маркет', 
    href: 'https://market.yandex.ru/business--pineapple/121584124?utm_source=121584124&clid=121584124&pp=605&distr_type=8',
    color: 'bg-[#FFCC00] hover:bg-[#E6B800] text-black'
  },
];

const INFO_LINKS = [
  { href: '/about', label: 'О нас' },
  { href: '/delivery', label: 'Доставка' },
  { href: '/payment', label: 'Оплата' },
  { href: '/service', label: 'Сервисный центр' },
];

const CATALOG_LINKS = [
  { href: '/catalog', label: 'Все ноутбуки' },
  { href: '/new', label: 'Новые' },
  { href: '/discounted', label: 'Уценка и витрина' },
  { href: '/sale', label: 'Акции' },
];

const LEGAL_LINKS = [
  { href: '/requisites', label: 'Реквизиты' },
  { href: '/privacy', label: 'Политика конфиденциальности' },
  { href: '/terms', label: 'Пользовательское соглашение' },
];

export function Footer() {
  const currentYear = new Date().getFullYear();
  const { settings } = useSiteSettings();
  
  return (
    <footer className="bg-gray-900 text-white">
      {/* Основной контент */}
      <div className="container mx-auto px-4 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-8 lg:gap-12">
          
          {/* Логотип и описание */}
          <div className="lg:col-span-4">
            <Link to="/" className="inline-flex items-center gap-3 mb-6 group">
              <div className="w-12 h-12 bg-[#FFCC00] rounded-xl flex items-center justify-center group-hover:scale-105 transition-transform">
                <img src="/logo.svg" alt="Big PineApple" className="w-8 h-8" />
              </div>
              <div>
                <span className="text-2xl font-bold">Big PineApple</span>
                <span className="block text-sm text-gray-400">Ноутбуки из США</span>
              </div>
            </Link>
            
            <p className="text-gray-400 mb-6 leading-relaxed">
              Качественные ноутбуки с гарантией. Проверяем каждое устройство перед продажей. 
              Доставка по всей России.
            </p>

            {/* Соцсети */}
            <div className="flex gap-3">
              {SOCIAL_LINKS.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-white/10 hover:bg-[#FFCC00] rounded-xl flex items-center justify-center text-gray-400 hover:text-black transition-all hover:scale-110"
                  aria-label={social.label}
                >
                  <social.icon />
                </a>
              ))}
            </div>
          </div>

          {/* Контакты */}
          <div className="lg:col-span-3">
            <h4 className="text-lg font-semibold mb-5">Контакты</h4>
            <ul className="space-y-4">
              <li>
                <a 
                  href={`tel:${settings.phone_number.replace(/[^\d+]/g, '')}`}
                  className="flex items-start gap-3 text-gray-400 hover:text-[#FFCC00] transition-colors group"
                >
                  <Phone className="w-5 h-5 mt-0.5 flex-shrink-0 group-hover:scale-110 transition-transform" />
                  <div>
                    <span className="block text-white font-medium">{settings.phone_number}</span>
                    <span className="text-sm">Звоните, поможем с выбором</span>
                  </div>
                </a>
              </li>
              <li>
                <a 
                  href={`mailto:${settings.contact_email}`}
                  className="flex items-center gap-3 text-gray-400 hover:text-[#FFCC00] transition-colors"
                >
                  <Mail className="w-5 h-5 flex-shrink-0" />
                  <span>{settings.contact_email}</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-gray-400">
                <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <div>
                  <span className="block text-white text-sm">{settings.address}</span>
                </div>
              </li>
              <li className="flex items-center gap-3 text-gray-400">
                <Clock className="w-5 h-5 flex-shrink-0" />
                <div className="text-sm">
                  <span className="text-white">{settings.working_hours}</span>
                </div>
              </li>
            </ul>
          </div>

          {/* Информация */}
          <div className="lg:col-span-2">
            <h4 className="text-lg font-semibold mb-5">Информация</h4>
            <ul className="space-y-3">
              {INFO_LINKS.map((link, index) => (
                <li key={index}>
                  <Link 
                    to={link.href} 
                    className="flex items-center gap-2 text-gray-400 hover:text-[#FFCC00] transition-colors group"
                  >
                    <ChevronRight className="w-4 h-4 opacity-0 -ml-5 group-hover:opacity-100 group-hover:ml-0 transition-all" />
                    <span>{link.label}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Каталог */}
          <div className="lg:col-span-3">
            <h4 className="text-lg font-semibold mb-5">Каталог</h4>
            <ul className="space-y-3">
              {CATALOG_LINKS.map((link, index) => (
                <li key={index}>
                  <Link 
                    to={link.href} 
                    className="flex items-center gap-2 text-gray-400 hover:text-[#FFCC00] transition-colors group"
                  >
                    <ChevronRight className="w-4 h-4 opacity-0 -ml-5 group-hover:opacity-100 group-hover:ml-0 transition-all" />
                    <span>{link.label}</span>
                  </Link>
                </li>
              ))}
            </ul>

            {/* Маркетплейсы */}
            <div className="mt-6 pt-6 border-t border-white/10">
              <h5 className="text-sm font-medium text-gray-400 mb-3">Мы на маркетплейсах</h5>
              <div className="flex flex-wrap gap-2">
                {MARKETPLACE_LINKS.map((mp, index) => (
                  <a 
                    key={index}
                    href={mp.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm text-white transition-colors ${mp.color}`}
                  >
                    {mp.name}
                    <ExternalLink className="w-3 h-3" />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Нижняя часть */}
      <div className="border-t border-white/10">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            {/* Копирайт */}
            <div className="flex items-center gap-2 text-gray-500 text-sm">
              <span>© {currentYear} Big PineApple.</span>
              <span className="hidden sm:inline">Все права защищены.</span>
              <span className="hidden md:inline-flex items-center gap-1">
                Сделано с <Heart className="w-3 h-3 text-red-500 fill-red-500" /> в Ростове-на-Дону
              </span>
            </div>

            {/* Правовые ссылки */}
            <div className="flex flex-wrap justify-center gap-4 text-sm">
              {LEGAL_LINKS.map((link, index) => (
                <Link 
                  key={index}
                  to={link.href} 
                  className="text-gray-500 hover:text-[#FFCC00] transition-colors"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
